import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CreateComponent } from './create/create.component';
import { EditComponent } from './edit/edit.component';
import { ViewComponent } from './view/view.component';
import { AuthGuard } from './shared/services/auth-guard.service';
import { CreatePermission, EditPermission, ViewPermission } from './shared/model/permission.model';
import { DefaultComponent } from './default/default.component';

export enum Routing {
  doc = 'doc',
  configured = 'configured',
  create = 'create',
  history = 'history',
  root = '',
  view = 'details/:id/view',
  edit = 'details/:id/edit',
  consumersenergy = 'consumersenergy*',
  demo = 'demo',
}

const routes: Routes = [
  {
    path: Routing.root,
    component: DefaultComponent,
    pathMatch: 'full',
    canActivate: [AuthGuard],
    data: { ...ViewPermission, title: 'Home' },
  },
  {
    path: Routing.doc,
    redirectTo: '/doc/index.html',
  },
  {
    path: Routing.create,
    component: CreateComponent,
    canActivate: [AuthGuard],
    data: { ...CreatePermission, title: 'Create Document' },
  },
  {
    path: Routing.edit,
    component: EditComponent,
    canActivate: [AuthGuard],
    data: { ...EditPermission, title: 'Edit Document' },
  },
  {
    path: Routing.view,
    component: ViewComponent,
    canActivate: [AuthGuard],
    data: { ...ViewPermission, title: 'View Details' },
  },
  {
    path: '**',
    redirectTo: '/' + Routing.root,
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
  providers: [AuthGuard],
})
export class AppRoutingModule {}
